<template>
  <div class="container">
    <pre style="display: none">{{ pagination | pretty_json }}}</pre>
    <h1>Lista de Estados</h1>
    <div class="card">
      <div class="card-body">
        <b-table striped hover :items="estados" :fields="fields">
          <template #cell(actions)="row">
            <Actions
              :item="row.item"
              :view_show="false"
              :view_edit="$can('estado:edit')"
              :view_delete="$can('estado:delete')"
              edit_to="estados_edit"
              @delete="delete_estado"
            />
          </template>
        </b-table>
      </div>
    </div>
    <div class="overflow-auto mt-4">
      <b-pagination-nav
        v-model="page"
        @input="loadData()"
        :link-gen="linkGen"
        :number-of-pages="pagination.last_page"
        use-router
      ></b-pagination-nav>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Actions },
  data: () => {
    return {
      page: 1,
    };
  },
  computed: {
    ...mapState("estados", ["estados", "pagination"]),
    fields() {
      return [
        { key: "id", label: "#" },
        { key: "sigla", label: "Sigla" },
        { key: "nome", label: "nome" },
        { key: "capital", label: "Capital" },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("estados", ["ActionGetAll"]),
    delete_estado(estado) {
      return estado;
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    await this.ActionGetAll({ page: this.page });
  },
};
</script>

<style></style>
